import React, { useEffect, useRef, useState } from "react";
import cssClasses from "./Projects.module.css";
import { useDispatch,useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import SearchBar from "../../Subcomponents/Search";
import debounce from "lodash.debounce";
import DropDown from "../../Subcomponents/DropDown";
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/MaskGroup2.svg";
import { Card } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { offlineToast } from "../../Services/Toast";
import { handleErrors } from "../../Services/LoginService";
import { getProjectsList } from "../../Services/LeadService";
import ProjectDefaultImg from "../../Assets/Images/projectDefaultImage.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import ViewMore from "../../Assets/Images/viewMoreIcon.svg";

// ? capacitor network for online/offline status
import { Network } from "@capacitor/network";
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  scroll_wrapper: {
    width: "100%",
    height: "100%",
  },
}));
const Projects = () => {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [allProjects, setAllProjects] = useState([]);
  const [projectsPresent, setProjectsPresent] = useState(null);
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  const scrollRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const styles = useStyles();
  useEffect(() => {
    dispatch(action.activeMenu("projects"));
  }, []);
  useEffect(() => {
    setPageNumber(0);
    setAllProjects([]);
    setLoadingStatus(0);
    setProjectsPresent(null);
    if (document.getElementById("projectsScrollableDiv")) {
      document.getElementById("projectsScrollableDiv").scrollTop = 0;
    }
    setTimeout(() => {
      // ? to get updated 'search' useState value
      Network.getStatus().then((res) => {
        if (res.connected) {
          getProjects(pageNumber, search, drpDownSelectedVal);
        } else {
          offlineToast();
        }
      });
    }, 100);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, drpDownSelectedVal]);
  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
  }, 800);
  function getProjects(pageNumber, search, drpDownSelectedVal) {
    pageNumber = pageNumber ? pageNumber : 0;
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        presentLoader();
        getProjectsList(
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          search,
          drpDownSelectedVal,
          loggedInUser?.cpId
        )
          .then((resp) => {
            console.log("resp: ", resp);
            setCount(resp.count);
            if (resp.count > resp.data.length) {
              setLoadingStatus(0);
              setPageNumber(1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            if (resp.count > 0) {
              resp.data = resp.data.map((el, index) => ({
                ...el,
                index: index,
                id: el.projectId.projectId,
              }));
              setProjectsPresent(true);
            } else {
              setProjectsPresent(false);
            }
            setAllProjects(resp.data);
            dismissLoader();
          })
          .catch((err) => {
            dismissLoader();
            handleErrors(err, "getProjects");
          });
        setLoadingStatus(0);
      } else {
        offlineToast();
      }
    });
  }
  function loadMoreProjects(pageNumber, search, drpDownSelectedVal) {
    Network.getStatus().then((res) => {
      if (res.connected) {
        presentLoader();
        getProjectsList(
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          search,
          drpDownSelectedVal
        )
          .then((resp) => {
            console.log("resp: ", resp);
            setCount(resp.count);
            if (resp.count > resp.data.length + allProjects.length) {
              setLoadingStatus(0);
              setPageNumber(pageNumber + 1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            if (resp.count > 0) {
              resp.data = resp.data.map((el, index) => ({
                ...el,
                index: index,
                id: el.projectId,
              }));
              setProjectsPresent(true);
            } else {
              setProjectsPresent(false);
            }
            setAllProjects(resp.data);
            dismissLoader();
          })
          .catch((err) => {
            dismissLoader();
            handleErrors(err, "getProjects");
          });
        setLoadingStatus(0);
      } else {
        offlineToast();
      }
    });
  }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div>
          <div className={cssClasses.headerTitle}>Projects</div>
          {/* <div className={cssClasses.headerSubTitle}>
                        Manage your Leads here.
                    </div> */}
        </div>
      </div>
      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.wrapperNameDropDown}>
          <div className={cssClasses.allLeadsTitle}>{count} Projects </div>
          <div className={cssClasses.wrapperDropDown}>
            {/* <div>Filter By</div> */}
            <DropDown
              list={[
                // "Name Ascending",
                // "Name Descending",
                "Latest First",
                "Oldest First",
              ]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
              }}
              placeHolder={"Select"}
              //style.color is placeHolder's color
              style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
              helperText={""}
            />
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>
          <SearchBar
            id={"StudentSearch"}
            placeholder={"Search"}
            search={debouncedFetchSearchData}
            width="100%"
          />
        </div>
      </div>
      <div className={cssClasses.wrapperTable} id="projectsScrollableDiv">
        <InfiniteScroll
          className={styles.scroll_wrapper}
          dataLength={allProjects.length}
          next={loadMoreProjects}
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%",
            flexWrap: "wrap",
            gap: "2rem",
          }} //To put endMessage and loader to the top.
          hasMore={loadingStatus === 0}
          scrollableTarget="projectsScrollableDiv"
        >
          {allProjects &&
            projectsPresent &&
            allProjects.map((project) => (
              <Card className={cssClasses.projectCard}>
                <div
                  className={cssClasses.projectInfo}
          
                 
                >
                  <div className={cssClasses.projectImg}>
                    <img
                      src={ProjectDefaultImg}
                      alt="Project"
                      className={cssClasses.projectImg}
                    />
                  </div>
                  <div className={cssClasses.projectname}>
                    {project?.projectId?.projectName}
                  </div>
                  <div className={cssClasses.projectLocation}>
                    {project?.projectId?.addressLine1} {project?.projectId?.addressLine2}
                  </div>
                  <div className={cssClasses.viewMore}
                    ><img src={ViewMore}
                    alt={"More"}
                    style={{cursor:'pointer'}}
                    onClick={() => {
                      navigate("/Home/Project/ViewProject");
                      localStorage.setItem('project', JSON.stringify(project.projectId))
                    }}
                    /></div>
                </div>
              </Card>
            ))}
        </InfiniteScroll>
        {projectsPresent === false && (
          // <div className="noDataMsg">No Leads</div>
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt="No Projects" />
            </div>
            <div className={cssClasses.emptyTitle}>No projects found</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
